import { render, staticRenderFns } from "./CreatePlate.vue?vue&type=template&id=2fe39508"
import script from "./CreatePlate.vue?vue&type=script&lang=js"
export * from "./CreatePlate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports